import type { Language } from "@helpers/I18nHelper";
import HandlevelPage from "@modules/handlevel/pages/HandlevelPage";
import LolProductDetailsPage from "@modules/productDetails/pages/LolProductDetailsPage";
import SmurfsRankedPage from "@modules/ranked/pages/SmurfsRankedPage";
import SkinChampionPage from "@modules/skins/SkinChampion/pages/SkinChampionPage";
import SkinPage from "@modules/skins/SkinDetails/pages/SkinPage";
import SkinSearchPage from "@modules/skins/SkinSearch/pages/SkinSearchPage";
import SmurfsNormalPage from "@modules/smurfs-normal/pages/SmurfsNormalPage";
import i18next from "i18next";
import type { RouteObject } from "react-router";

const getLoLRoutes = (lang: Language): RouteObject[] => {
  const t = (key: string) => i18next.t(`routes.public.${key}`, { lng: lang });

  return [
    {
      element: <SmurfsRankedPage />,
      path: t("smurfs_ranked"),
      handle: { routeId: "smurfs_ranked" },
    },
    {
      element: <SmurfsRankedPage />,
      path: `${t("smurfs_ranked")}/:region`,
      handle: { routeId: "smurfs_ranked_region" },
    },
    {
      element: <SmurfsNormalPage />,
      path: t("smurfs_normal"),
      handle: { routeId: "smurfs_normal" },
    },
    {
      element: <SmurfsNormalPage />,
      path: `${t("smurfs_normal")}/:region`,
      handle: { routeId: "smurfs_normal_region" },
    },
    {
      element: <LolProductDetailsPage />,
      path: `${t("smurfs_normal")}/:region/:slug`,
      handle: { routeId: "smurfs_normal_slug" },
    },
    {
      element: <HandlevelPage />,
      path: t("smurfs_handlevel"),
      handle: { routeId: "smurfs_handlevel" },
    },
    {
      element: <HandlevelPage />,
      path: `${t("smurfs_handlevel")}/:region`,
      handle: { routeId: "smurfs_handlevel_region" },
    },
    {
      element: <LolProductDetailsPage />,
      path: `${t("smurfs_handlevel")}/:region/:slug`,
      handle: { routeId: "smurfs_handlevel_slug" },
    },
    {
      element: <SkinSearchPage />,
      path: t("smurfs_skin"),
      handle: { routeId: "smurfs_skin" },
    },
    {
      element: <SkinChampionPage />,
      path: `${t("smurfs_skin")}/:slugChampion`,
      handle: { routeId: "smurfs_skin_champion" },
    },
    {
      element: <SkinPage />,
      path: `${t("smurfs_skin")}/:slugChampion/:slugSkin`,
      handle: { routeId: "smurfs_skin_champion_skin" },
    },
  ];
};

export default getLoLRoutes;
